import type { ReactNode } from "react";

import clsx from "clsx";
import { Switch } from "react-aria-components";
import { useController, useFormContext } from "react-hook-form";

import styles from "./toggle.module.css";

type ToggleProps = {
	description?: string;
	label: string;
	name: string;
};

export function Toggle({ description, label, name }: ToggleProps): ReactNode {
	const { control } = useFormContext();
	const { field } = useController({ control, name });

	return (
		<Switch
			className={styles.toggle}
			isSelected={Boolean(field.value)}
			onChange={field.onChange}
		>
			<span className={styles.text}>
				<span className={clsx("body-2", styles.label)}>{label}</span>
				{description && (
					<span className={clsx("caption", styles.description)}>{description}</span>
				)}
			</span>
			<span aria-hidden className={styles.track}>
				<span className={styles.thumb} />
			</span>
		</Switch>
	);
}
